import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-shared',
    templateUrl: './shared.component.html',
    standalone: false
})
export class SharedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
